var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2970_1110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13.1992C16.0017 12.8163 15.8928 12.4412 15.6865 12.1187C15.4802 11.7962 15.1853 11.5401 14.837 11.3812C12.6811 10.443 10.351 9.97204 8.00002 9.99915C5.64902 9.97204 3.31892 10.443 1.16302 11.3812C0.814771 11.5401 0.519799 11.7962 0.313505 12.1187C0.107211 12.4412 -0.00163935 12.8163 1.86626e-05 13.1992V15.9992H16V13.1992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2970_1110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c7221b4c8b0a6d14aa7637248d5c77f7.svg";
export { ForwardRef as ReactComponent };